import React from 'react';
import { Modal, Input, Button, Form, Popconfirm, Icon, message } from 'antd';
import PropTypes from 'prop-types';
import CelaneseAPI from '../../services';
import { connect } from 'react-redux';
import { utils } from '../../config';
import Translation from '../../Translation';
import './ShareWithEmail.css';

const FormItem = Form.Item;

/**
 *
 * class shares the data with other users
 * @class ShareWithEmail 
 * @extends {React.Component}
 */
class ShareWithEmail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            popoverText: '',
            email: [],
            loading: false,
            emailVal: '',
            flag: false,
            iconColor: '',
            iconType: '',
            isSuccessful: false,
            visible: false
        };

    }

    error = () => {
        message.error( utils.getTranslationText('msg_some_issue', 'There was some issue.'), 2);
    };

    /**
     * handleCancel closes the share with email window
     *
     * @param {*} e
     * @memberof ShareWithEmail
     */
    handleCancel(e) {
        if (e.target.tagName === 'path' || e.target.tagName === 'BUTTON' || e.target.tagName === 'svg' || (typeof e.target.className === 'string' && (e.target.className.indexOf('ant-modal-close-icon') >= 0 || e.target.className.indexOf('ant-modal-close-x') >= 0))) {
            this.props.showShareWithEmail(false);
            this.props.getData();
        }
    }
    /**
     * objIsEmpty checks if object is empty
     * @param {object} obj
     * @memberof ShareWithEmail
     */
    objIsEmpty = (obj) => {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    /**
     *
     * Sharedata function , depending on the user selection appropriate objects are created and postshareddata is called
     * @memberof ShareWithEmail
     */
    shareData = () => {
        this.setState({
            loading: true
        });
        let value = this.state.emailVal;

        if (value && value.length !== 0 && this.state.flag) {
            if (!this.objIsEmpty(this.props.selectedFilter)) {
                let filterObj = {
                    "shareType": "FILTER_BRAND",
                    "sharedTo": this.state.emailVal,
                    "sharedData": this.props.selectedFilter
                };

                this.postSharedData(filterObj);
            }
            if (!this.objIsEmpty(this.props.selectedCigarette)) {
                let cigaretteObj = {
                    "shareType": "CIGARETTE_BRAND",
                    "sharedTo": this.state.emailVal,
                    "sharedData": this.props.selectedCigarette
                }

                this.postSharedData(cigaretteObj);
            }
            if (!this.objIsEmpty(this.props.selectedCarbonFilter)) {
                let filterCarbonObj = {
                    "shareType": "CARB_FILTER_BRAND",
                    "sharedTo": this.state.emailVal,
                    "sharedData": this.props.selectedCarbonFilter
                };

                this.postSharedData(filterCarbonObj);
            }
            if (!this.objIsEmpty(this.props.selectedCarbonCigarette)) {
                let cigaretteCarbonObj = {
                    "shareType": "CARB_CIGARETTE_BRAND",
                    "sharedTo": this.state.emailVal,
                    "sharedData": this.props.selectedCarbonCigarette
                }
                this.postSharedData(cigaretteCarbonObj);
            }
        }
        else {
            this.setState({
                popoverText: this.state.popoverText,
                iconColor: 'red',
                iconType: 'exclamation-circle',
                loading: false
            }, () => {
                this.setState({
                    visible: true
                })
            });
        }
    }

    /**
     *postSharedData function shares the data with the email specified after validating if the email exixts in database
     *
     *@param {Object} obj which is object, has data about what is being shared 
     * @memberof ShareWithEmail
     */
    postSharedData = (obj) => {
        if (this.state.flag) {
            CelaneseAPI.post('/share-entity', obj).then((res) => {
                if (res.error) {
                    if (res.code === 'EMAIL_NOT_EXISTS') {
                        this.setState({
                            popoverText:  utils.getTranslationText('err_msg_email_not_exits', 'Email does not exist in the application'),
                            iconColor: 'red',
                            iconType: 'exclamation-circle',
                            loading: false
                        }, () => {
                            this.setState({
                                visible: true
                            })
                        });
                    } else if (res.code === 'CANT_SHARE_YOURSELF') {
                        this.setState({
                            popoverText:  utils.getTranslationText('msg_you_cannot_shre_yourself', 'You cannot share with yourself'),
                            iconColor: 'yellow',
                            iconType: 'info-circle',
                            loading: false
                        }, () => {
                            this.setState({
                                visible: true
                            })
                        });
                    } else {
                        this.setState({
                            popoverText:  utils.getTranslationText('msg_unable_to_share', 'Unable to Share Items'),
                            iconColor: 'red',
                            iconType: 'exclamation-circle',
                            loading: false
                        }, () => {
                            this.setState({
                                visible: true
                            })
                        });
                    }
                }
                else {
                    this.setState({
                        popoverText: utils.getTranslationText('msg_data_success_shared', 'Data successfully shared'),
                        iconColor: 'green',
                        iconType: 'check-circle',
                        loading: false,
                        isSuccessful: true
                    }, () => {

                        this.setState({
                            visible: true
                        })
                    });
                }
            }).catch(() => {
                this.setState({
                    loading: false
                });
                this.error();
            });
        }
        else {
            this.setState({
                popoverText: utils.getTranslationText('msg_error', 'error'),
                iconColor: 'red',
                iconType: 'exclamation-circle',
                loading: false
            }, () => {

                this.setState({
                    visible: true
                })
            });
        }
    }
    /**
     *validateEmail checks the validity of the email
     * @param {String} email
     * @memberof ShareWithEmail
     */
    validateEmail = (email) => {
        var re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    validateInputFields = (rule, value, callback) => {

        if (value.length === 0) {
            callback( utils.getTranslationText('msg_you_have_empty_field', 'You cannot have empty field'));
            this.setState({
                popoverText: utils.getTranslationText('msg_you_have_empty_field', 'You cannot have empty field'),
                flag: false
            });
        }
        else if (!this.validateEmail(value)) {
            callback( utils.getTranslationText('msg_email_not_valid', 'Email is not valid'));
            this.setState({
                popoverText: utils.getTranslationText('msg_email_not_valid', 'Email is not valid'),
                flag: false
            });
        }
        else {
            callback();
            this.setState({
                emailVal: value,
                flag: true
            });
        }
    }
    /**
     * conformclose closes the popover displaying the error message and if data is shared successfully closes the share with email window
     *
     * @memberof ShareWithEmail
     */
    confirmClose = () => {
        if (this.state.isSuccessful) {
            this.setState({
                isSuccessful: false
            }, () => {
                this.props.showShareWithEmail(false);
                this.props.getData();
            });
        }
        this.setState({
            visible: false
        });
    }
    /**
     *
     * cancelClose closes the popover displaying error messages
     * @memberof ShareWithEmail
     */
    cancelClose = () => {
        this.setState({
            visible: false
        });
    }

    render() {
        const confirmText = this.state.popoverText;
        const { getFieldDecorator } = this.props.form;

        return (
            <div>
                <Modal
                    title={<Translation labelName="lbl_share_data" defaultText="Share Data"/>}
                    visible={this.props.isShareWithEmailVisible}
                    footer={null}
                    width="30%"
                    bodyStyle={{ height: 180 }}
                    centered
                    style={{ top: 20 }}
                    onCancel={(e) => this.handleCancel(e)}>
                    <div className="shareEmail-container">
                        <div>
                            <Form>
                                <FormItem label={<Translation labelName="lbl_enter_email" defaultText="Enter Email"/>}>
                                    {getFieldDecorator('emailVal', {
                                        rules: [
                                            { validator: this.validateInputFields, }],
                                    })(
                                        <Input />
                                    )}
                                </FormItem>

                                <div className="email-btn-wrapper ">
                                    <Popconfirm
                                        title={confirmText}
                                        okText={<Translation labelName="btn_close" defaultText="Close"/>}
                                        cancelText={<Translation labelName="btn_cancel" defaultText="Cancel"/>}
                                        visible={this.state.visible}
                                        onConfirm={this.confirmClose}
                                        onCancel={this.cancelClose}
                                        placement="topLeft"
                                        icon={<Icon type={this.state.iconType} style={{ color: this.state.iconColor }} />}>
                                        <Button
                                            type="primary"
                                            className="btn btn-primary shareEmail-container__share"
                                            loading={this.state.loading}
                                            disabled={!this.state.flag}
                                            onClick={() => this.shareData()}>
                                              <Translation labelName="btn_share" defaultText="SHARE" />
                                        </Button>
                                    </Popconfirm>
                                </div>
                            </Form>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

const DefaultShareWithEmail = Form.create()(ShareWithEmail);
const mapStateToProps = ({ loggedUserState }) => ({
    prefData: loggedUserState.prefData
});

export default connect(mapStateToProps, null)(DefaultShareWithEmail);

ShareWithEmail.propTypes = {
    isShareWithEmailVisible: PropTypes.bool,
    showShareWithEmail: PropTypes.func,
    selectedFilter: PropTypes.object,
    selectedCigarette: PropTypes.object,
    selectedCarbonFilter: PropTypes.object,
    selectedCarbonCigarette: PropTypes.object,
    prefData: PropTypes.object,
    getData: PropTypes.func,
    form: PropTypes.object,
};


// WEBPACK FOOTER //
// ./src/components/ShareWithEmail/index.js